import { mergeTypeDefs } from "@graphql-tools/merge"
import { typeDefs as scalarTypeDefs } from "graphql-scalars"

import anniversarySchema from "./schemas/anniversary"
import articleSchema from "./schemas/article"
import articleGroupSchema from "./schemas/article-group"
import articleMainGroupSchema from "./schemas/article-main-group"
import bonusSchema from "./schemas/bonus"
import branchOfficeSchema from "./schemas/branch-office"
import brandSchema from "./schemas/brand"
import cartSchema from "./schemas/cart"
import customTypeSchema from "./schemas/commerce-custom-type"
import complaintSchema from "./schemas/complaint"
import customerSchema from "./schemas/customer"
import customerAddressSchema from "./schemas/customer-address"
import downloadCenterSchema from "./schemas/download-center"
import mixProductSchema from "./schemas/mix-product"
import noteSchema from "./schemas/note"
import obligationSchema from "./schemas/obligation"
import orderSchema from "./schemas/order"
import priceSchema from "./schemas/price"
import productSchema from "./schemas/product"
import productStockSchema from "./schemas/product-stock"
import revenueSchema from "./schemas/revenue"
import sharedSchema from "./schemas/shared"
import specialConditionsSchema from "./schemas/special-conditions"
import specialOfferSchema from "./schemas/special-offer"
import tourPlanningSchema from "./schemas/tour-planning"
import tourScheduleSchema from "./schemas/tour-schedule"
import userSchema from "./schemas/user"
import vendorSchema from "./schemas/vendor"
import visitReportSchema from "./schemas/visit-report"

const typeDefs = mergeTypeDefs([
  scalarTypeDefs,
  ...articleGroupSchema.types,
  ...articleMainGroupSchema.types,
  ...articleSchema.types,
  ...brandSchema.types,
  ...branchOfficeSchema.types,
  ...cartSchema.types,
  ...customerSchema.types,
  ...customerAddressSchema.types,
  ...mixProductSchema.types,
  ...noteSchema.types,
  ...orderSchema.types,
  ...priceSchema.types,
  ...productSchema.types,
  ...productStockSchema.types,
  ...revenueSchema.types,
  ...sharedSchema.types,
  ...specialOfferSchema.types,
  ...specialConditionsSchema.types,
  ...tourPlanningSchema.types,
  ...tourScheduleSchema.types,
  ...vendorSchema.types,
  ...visitReportSchema.types,
  ...bonusSchema.types,
  ...obligationSchema.types,
  ...userSchema.types,
  ...customTypeSchema.types,
  ...complaintSchema.types,
  ...anniversarySchema.types,
  ...downloadCenterSchema.types,
])

export { typeDefs }

export default typeDefs
